import { useCallback, useContext } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { ThemeGroupSelectContext } from '../contexts';
import styles from './Select.module.css';

type Props = {
  onClick: () => void;
};

export const CreateThemeButton = ({ onClick }: Props): React.JSX.Element => {
  const select = useContext(ThemeGroupSelectContext);

  if (!select) {
    throw new Error('CreateThemeButton must be used within ThemeGroupSelectContext');
  }

  const handleClick = useCallback(() => {
    onClick();
    select.close();
  }, [onClick, select]);

  return (
    <MenuItem
      classes={{ root: styles.create }}
      disableRipple
      onClick={handleClick}>
      <div className={styles.item}>
        <div className={styles.text}>+ Create Theme</div>
      </div>
    </MenuItem>
  );
};

CreateThemeButton.displayName = 'ChartTheming.CreateThemeButton';
